import { OutletSubmitRequest } from "../../services/dto/outlet";

export function createOutletSubmitRequest(
  action: string,
  values?: Record<string, any>
): OutletSubmitRequest {
  return {
    code: values?.code,
    name: values?.name,
    address: values?.address,
    phone: values?.phone,
    locId: values?.locId,
    latitude: values?.latitude,
    longitude: values?.longitude,
    cityCode: values?.city?.value,
    action: action,
  };
}

export function createInitialValue(data: any) {
  return {
    code: data?.code,
    address: data?.address,
    phone: data?.phone,
    latitude: data?.latitude,
    locId: data?.locId,
    name: data?.name,
  };
}
